module.exports = __webpack_public_path__ + "img/logo-imobcoin.6b806994.png";